'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { ArrowRight, Store } from 'lucide-react';

export function StickyFooterCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      const heroSection = document.querySelector('#hero');
      setIsVisible(Boolean(heroSection && heroSection.getBoundingClientRect().bottom <= 0));
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();

    return () => {
      window.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('resize', updateVisibility);
    };
  }, []);

  return (
    <div
      className={`fixed inset-x-4 bottom-[max(0.75rem,env(safe-area-inset-bottom))] z-[60] flex justify-center transition-all duration-300 motion-reduce:transition-none sm:hidden ${
        isVisible
          ? 'pointer-events-auto translate-y-0 opacity-100'
          : 'pointer-events-none translate-y-4 opacity-0'
      }`}
      aria-hidden={!isVisible}
    >
      <Link
        href="/registro/"
        tabIndex={isVisible ? undefined : -1}
        data-cta-location="mobile_sticky_button"
        data-cta-text="Crea tu perfil gratis"
        className="flex min-h-14 w-full max-w-sm items-center gap-3 rounded-full bg-accent p-1.5 pr-2 font-heading text-bg-primary shadow-[0_14px_36px_-12px_rgb(var(--color-accent)/0.72)] transition-colors hover:bg-accent-hover"
      >
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-bg-primary text-accent">
          <Store size={20} strokeWidth={2.2} aria-hidden="true" />
        </span>
        <span className="min-w-0 flex-1 truncate text-sm font-semibold">
          Crea tu perfil gratis
        </span>
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-bg-primary text-accent">
          <ArrowRight size={19} strokeWidth={2.2} aria-hidden="true" />
        </span>
      </Link>
    </div>
  );
}
